<template>
  <div>
    <div class="register-top">
      <div v-if="!user.picture.length">
        <h2 class="mb-6">{{ $t('register.upload.title') }}</h2>
      </div>
      <!-- <input type="file" accept="image/*" capture="camera" /> -->
      <v-row>
        <v-col
          v-for="(picture, index) in user.picture"
          :key="index"
          cols="6"
          md="3"
        >
          <v-img
            :src="
              picture.url.replace(
                'sites/default/files/pictures',
                'sites/default/files/styles/portrait/public/pictures'
              )
            "
          />
        </v-col>
        <v-col cols="6" md="3">
          <label v-if="user.picture.length < 4" for="pictureUpload">
            <div class="register-addpicture">
              <div v-if="loading">
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
                <br />
                {{ $t('register.upload.loading') }}
              </div>
              <div v-else>{{ $t('register.upload.take_picture') }}</div>
            </div>
          </label>
        </v-col>
      </v-row>
      <!-- <img v-if="user.picture" :src="user.picture" style="max-width: 300px;" /> -->
    </div>
    <div class="register-bottom">
      <register-base-button
        :to="{ name: 'Validation' }"
        :disabled="user.picture.length < 1"
        gradient="linear-gradient(90deg, #00DABE 0%, #7444C6 100%)"
      >
        {{ $t('register.upload.validate') }}
      </register-base-button>
      <br />
      <a
        href="#"
        v-if="user.picture.length"
        @click.prevent="reset"
        class="register-link mb-4"
      >
        {{ $t('register.upload.take_again') }}
      </a>
      <br />
      <router-link :to="{ name: 'Problem' }" class="register-link">
        {{ $t('register.upload.problem') }}
      </router-link>
    </div>
    <input
      id="pictureUpload"
      type="file"
      ref="file"
      @change="handleFileUpload()"
      style="display:none"
    />
  </div>
</template>

<script>
import RegisterBaseButton from '@/components/RegisterBaseButton'

export default {
  data() {
    return {
      loading: false
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/get']
    }
  },
  methods: {
    handleFileUpload() {
      const file = this.$refs.file.files[0]

      if (file) {
        this.loading = true
        const reader = new FileReader()
        reader.readAsArrayBuffer(file)
        reader.onload = () => {
          this.$store.dispatch('user/patch', reader.result).then(() => {
            this.loading = false
          })
        }
      }
    },
    reset() {
      this.$store.dispatch('user/patch', null)
    }
  },
  components: {
    RegisterBaseButton
  }
}
</script>

<style lang="scss">
.register-addpicture {
  position: relative;
  padding-top: 100%;
  border-radius: 5px;
  background: #eee;
  cursor: pointer;

  > div {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 20px;
  }
}
</style>
